import { SafeResourceUrl } from "@angular/platform-browser";

export interface ExternalViewStats {
  type: ExternalViewType;
  dateOpen: Date;
  dateClose: Date;
  externalId: string;
  link: string | SafeResourceUrl;
  searchTerms: string;
}

export enum ExternalViewType {
  YOUTUBE = 'YOUTUBE',
}
